import { Box, Button, Checkbox, Divider, VStack } from "@chakra-ui/react"
import FacetCount from "@components/Search/Filters/FacetCount"
import { useRefinementList } from "@hooks/search/useRefinementList"
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList"
import { ChangeEvent, useCallback } from "react"
import type { UseRefinementListProps } from "react-instantsearch-core"

function FilterList(props: UseRefinementListProps) {
  const { items, refine, toggleShowMore, canToggleShowMore, isShowingMore } =
    useRefinementList({
      ...props,
      sortBy: ["isRefined", "count", "name"],
      showMore: true,
      showMoreLimit: 20,
    })

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    refine(event.target.value)
  }

  const refinedItems = items?.filter((item) => item.isRefined)
  const unrefinedItems = items?.filter((item) => !item.isRefined)
  const { attribute } = props

  const getLabel = useCallback(
    (attribute: string, item: RefinementListItem) => {
      const predefinedLabels = [
        { key: "largePrint", label: "Large Print" },
        {
          key: "tableOfContents",
          label: "Table of Contents",
        },
      ]
      if (attribute === "accessibilityFeature") {
        return predefinedLabels.find(
          (predefinedLabel) => predefinedLabel.key === item.value
        )?.label
      } else {
        return item.label
      }
    },
    []
  )

  /* TODO: Fix required after dynamic widgets was turned on, this wont work - facet_by error */
  /***
   {!hasExhaustiveItems && (
   <Input
   placeholder={"search"}
   size={"md"}
   onChange={(event) => searchForItems(event.target.value)}
   onKeyUp={(event) => {
   if (event.key === "Enter") {
   event.preventDefault()
   event.currentTarget.blur()
   }
   }}
   enterKeyHint={"search"}
   />
   )}
   ***/

  return (
    <VStack
      spacing={4}
      alignItems={"flex-start"}
    >
      {items && items.length > 0 ? (
        <VStack alignItems={"start"}>
          {refinedItems.map((item) => (
            <Checkbox
              key={item.value}
              isChecked={item.isRefined}
              onChange={handleChange}
              value={item.value}
              colorScheme={"yellow"}
            >
              <Box
                as={"span"}
                fontSize={"sm"}
              >
                {getLabel(attribute, item)}
              </Box>
              <FacetCount count={item.count} />
            </Checkbox>
          ))}
          {refinedItems.length > 0 && <Divider />}
          {unrefinedItems.map((item) => (
            <Checkbox
              key={item.value}
              isChecked={item.isRefined}
              onChange={handleChange}
              value={item.value}
            >
              <Box
                as={"span"}
                fontSize={"sm"}
              >
                {getLabel(attribute, item)}
              </Box>
              <FacetCount count={item.count} />
            </Checkbox>
          ))}
        </VStack>
      ) : (
        <Box fontSize={"xs"}>{"No filter options available"}</Box>
      )}
      {canToggleShowMore && !isShowingMore && (
        <Button
          size={"xs"}
          onClick={() => toggleShowMore()}
        >
          {"Show More"}
        </Button>
      )}
    </VStack>
  )
}

export default FilterList
